import NewGroupMessage from "./NewGroupMessage";

export default NewGroupMessage;
